import styled from 'styled-components';

export const TriggerButton = styled.div.attrs({ className: 'overline' })<{ $frozen?: boolean }>`
  cursor: ${({ $frozen }) => ($frozen ? 'normal' : 'pointer')};
  margin-left: 15px;
  line-height: 25px;
  height: 100%;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const LabelSelectorContainer = styled.div`
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const LabelsWrapper = styled.div`
  margin: 0 -5px;
  padding: 5px 0;
  display: flex;
  flex-wrap: wrap;
`;

export const LabelContainer = styled.div`
  margin: 5px;
`;
